<template>
   <div>
      <div class=" container-fluid">
        <div class="llp-container-section  heightcontainer ">
      <top-header id="height2"></top-header>
      <main-menu id="height3"></main-menu>
      <!-- Start the code for this screen here -->
        <div v-if="popUpType=='viewDealer'">
      <div class=" container-fluid menu-margin-top"  >
      <div class="modal-backdrop">
        <div class="card col-lg-10 col-md-8 mt-md-4 col-11 p-0">

            <div class="postmodalcontent" >
                <div class="modal-header borderbottom p-4">

                    <button type="button" class="close" @click="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                 <div class="modal-body bodymodal11">

         <div>
            <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b>Edit Dealer Account</b></span></nav>
            <div v-if="saved">
               <p align ="center" class="confirm-message"> {{message}} </p>
            </div>
            <div v-if="failure">
               <p align ="center" class="alert-danger"> {{failureMessage}} </p>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="dealerName" class="col-form-label col-form-label-sm required" > Dealer Name </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input type="text" data-vv-as="Dealer Name" v-validate="'required'" class="form-control input-sm "  name="DName" v-model.trim="dealer.dealerName" autofocus placeholder="Enter Dealer Name" :maxlength="100" >
                  <div v-if="errors.has('DName')" class="alert-danger" > {{ errors.first('DName') }} </div>
               </div>
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="line1" class="col-form-label col-form-label-sm"> Contact Title </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input type="text"  v-model.trim="dealer.contactTitle" placeholder="Enter Contact Title"  class="form-control input-sm " :maxlength="50" >
               </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="line1" class="col-form-label col-form-label-sm"> Primary Contact First Name </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input type="text"  v-model.trim="dealer.firstName" placeholder="Enter First Name" class="form-control input-sm " :maxlength="50" >
               </div>
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="line2" class="col-form-label col-form-label-sm"> Primary Contact Middle Name </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input type="text"  v-model.trim="dealer.middleName" placeholder="Enter Middle Name" class="form-control input-sm " :maxlength="50" >
               </div>
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="city" class="col-form-label col-form-label-sm"> Primary Contact Last Name </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input type="text"  v-model.trim="dealer.lastName" placeholder="Enter Last Name" class="form-control input-sm " :maxlength="50" >
               </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="line1" class="col-form-label col-form-label-sm"> Address Line1 </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input type="text"  data-vv-as="Address Line1" class="form-control input-sm "   name="Line1" v-model.trim="dealer.addressLine1" placeholder="Enter Address Line1" :maxlength="50">
                  <div v-if="errors.has('Line1')" class="alert-danger" > {{ errors.first('Line1') }} </div>
               </div>
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="line2" class="col-form-label col-form-label-sm"> Address Line2 </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input type="text"   name="Address Line2" class="form-control input-sm " v-model.trim="dealer.addressLine2" placeholder="Enter Address Line2" :maxlength="50">
               </div>
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="city" class="col-form-label col-form-label-sm"> City </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input type="text"   name="City"  data-vv-as="City" class="form-control input-sm " v-model.trim="dealer.city" placeholder="Enter City" :maxlength="50">
                  <div v-if="errors.has('City')" class="alert-danger" > {{ errors.first('City') }} </div>
               </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="state" class="col-form-label col-form-label-sm"> State </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <select name="State" v-model.trim="dealer.stateCode"  data-vv-as="State" class="form-control input-sm "  >
                     <option disabled value=""> Select a State </option>
                     <option v-for="state in states" v-bind:value="state.stateFipsC" v-bind:key="state.stateFipsC">{{state.stateN}} </option>
                  </select>
                  <div v-if="errors.has('State')" class="alert-danger" > {{ errors.first('State') }} </div>
               </div>
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="country" class="col-form-label col-form-label-sm"> Country </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input type="text" name="Country" v-model.trim="dealer.country" class="form-control input-sm " disabled>
               </div>
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="zip" class="col-form-label col-form-label-sm"> Zip Code </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input type="text" name="Zip" data-vv-as="Zip Code" class="form-control input-sm " v-validate="{  regex: /^(\d)(?!\1+$)/, digits:5 }" v-model.trim="dealer.zipcode" @input="zipDecoder" placeholder="Enter 5 Digit zip" :maxlength="5">
                  <div v-if="errors.has('Zip')" class="alert-danger" > {{ errors.first('Zip') }} </div>
               </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="workNumber" class="col-form-label col-form-label-sm"> Office Number </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input type="text"  name="Office Number" class="form-control input-sm " @input="formatPhoneNumber" @blur="formatPhoneNumber" v-model.trim="dealer.officeNum" v-validate="'min:10|max:14'" data-vv-as="Office Number" placeholder="Enter Office Number" :maxlength="10">
                  <div v-if="errors.has('Office Number')" class="alert-danger" > {{ errors.first('Office Number') }} </div>
               </div>
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="email" class="col-form-label col-form-label-sm"> Email </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input type="text" name="Email"  v-validate="'email'" class="form-control input-sm "
                     data-vv-as="Email" v-model.trim="dealer.email"  placeholder="Enter Email" :maxlength="50">
                  <div v-if="errors.has('Email')" class="alert-danger" > {{ errors.first('Email') }} </div>
               </div>
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="contactmethod" class="col-form-label col-form-label-sm" > Contact </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <select id="contactmethod" v-model.trim="dealer.preferredContact" class="form-control input-sm " disabled >
                     <option v-for="contact in preferredContactOptions" v-bind:value="contact.value" v-bind:key="contact.value">{{contact.text}}  </option>
                  </select>
                  <div v-if="errors.has('Contact')" class="alert-danger" > {{ errors.first('Contact') }} </div>
               </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="status" class="col-form-label col-form-label-sm" > Dealer Status </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <select name="status"  v-if="this.disableemployeedd"  disabled v-model.trim="dealer.status" class="form-control input-sm " data-vv-as="Status" >
                     <option v-for="dstatus in dealerStatusOptions" v-bind:value="dstatus.value" v-bind:key="dstatus.value">{{dstatus.text}} </option>
                  </select>
                  <select name="status"  v-else  v-model.trim="dealer.status"  data-vv-as="Status" class="form-control input-sm ">
                     <option v-for="dstatus in dealerStatusOptions" v-bind:value="dstatus.value" v-bind:key="dstatus.value">{{dstatus.text}} </option>
                  </select>
                  <div v-if="errors.has('Status')" class="alert-danger" > {{ errors.first('Status') }} </div>
               </div>
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label for="priority" class="col-form-label col-form-label-sm"> Priority </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <select name="Priority" v-model.trim="dealer.priority" data-vv-as="Priority" class="form-control input-sm " disabled >
                     <option disabled value=""> Select Priority </option>
                     <option v-for="priority in priortyList" v-bind:key="priority.key">{{priority.value}} </option>
                  </select>
                  <div v-if="errors.has('Priority')" class="alert-danger" > {{ errors.first('Priority') }} </div>
               </div>
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label class="col-form-label col-form-label-sm"> Salesperson </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <select  v-model.trim="assignedAgentID"  v-if="this.disableemployeedd" class="form-control input-sm "  disabled>
                     <option  disabled value=""> Select a Salesperson </option>
                     <option v-for="(option,index) in agentList" v-bind:value="option.employeeId" v-bind:key="index"> {{ option.firstName }} {{ option.middleName.length !=0 ?  ',' +option.middleName : ''}} , {{ option.lastName }} </option>
                  </select>
                  <select v-else v-model.trim="assignedAgentID" class="form-control input-sm " >
                     <option  disabled value=""> Select a Salesperson </option>
                     <option  value="RA"> REMOVE AGENT </option>
                     <option v-for="(option,index) in agentList" v-bind:value="option.employeeId" v-bind:key="index"> {{ option.firstName }} {{ option.middleName.length !=0 ?  ',' +option.middleName : ''}} , {{ option.lastName }} </option>
                  </select>
               </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end">
                  <label for="priority" class="col-form-label col-form-label-sm"> App Source </label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <select name="AppSource" v-model.trim="dealer.appSource" class="form-control input-sm " data-vv-as="AppSource">
                     <option disabled value=""> Select an App Source </option>
                     <option v-for="appSource in appSourceList" v-bind:key="appSource.key">{{appSource.value}} </option>
                  </select>
               </div>
                <div class="col-12 col-md-12 d-flex justify-content-lg-end">
        <label for="priority" class="col-form-label col-form-label-sm"> Fraud Indicator </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <select  name="fraudIndicator" placeholder="Select fraudIndicator" v-model.trim="dealer.fraudInd" data-vv-as="indicator" class="form-control input-sm">
          <option v-for="indicator in fraudIndicatorList" v-bind:key="indicator.key">{{indicator.keyValue}} </option>
        </select>
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end" v-if="dealer.fraudInd == 'Y' || dealer.fraudCell == 'Y'">
        <label for="priority" class="col-form-label col-form-label-sm">Red Flag Reason</label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 " v-if="dealer.fraudInd == 'Y' || dealer.fraudCell == 'Y'">
       <select v-model.trim="dealer.redFlagReason" class="form-control input-sm">
            <option disabled value="">Select Redflag Reason</option>
            <option
              v-for="(indicator,index) in redFlagReasonList"
              v-bind:key="index"
            >{{indicator.keyValue}}</option>
          </select>
        </div>

       </div>

            <br/>
            <div :hidden="hiddeninactivestatus" v-if="this.reviewlist.length!=0 || this.addSecondaryContact==true">
               <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b>Secondary Contacts</b></span></nav>
               <br>
        <div class="table-responsive-sm">
              <table id="dealerstable"   class="table table-sm table-bordered table-striped ">
      <thead>
                   <tr class="table-month-header-blue">

                        <th v-for="(dach,index) in secondarycontactscolnames" :key="index">{{ dach.header }}</th>
                     </tr>
      </thead>
                     <tr v-if="this.addSecondaryContact== true">
                        <!--<td class="table-month-td"><input type="text" v-model="rownumber"></td>-->
                        <td>
                           <input type="text" data-vv-scope="addscontact" class="form-control input-sm" v-validate="'required'" name="First Name" data-vv-as="First Name" placeholder="Enter First Name" :maxlength="50" v-model="secondaryContactList.secondaryContactFirstName">
                           <div v-if="errors.has('addscontact.First Name')" > {{ errors.first('addscontact.First Name') }} </div>
                        </td>
                        <td><input type="text" placeholder="Enter Middle Name" class="form-control input-sm" :maxlength="50" v-model="secondaryContactList.secondaryContactMiddleName"></td>
                        <td>
                           <input type="text" name="Last Name" data-vv-as="Last Name"  class="form-control input-sm" placeholder="Enter Last Name" :maxlength="50"  v-model="secondaryContactList.secondaryContactLastName">
                           <div v-if="errors.has('Last Name')"> {{ errors.first('Last Name') }} </div>
                        </td>
                        <td>
                           <input type="text" name='Contact Title' data-vv-as="Contact Title" class="form-control input-sm" placeholder="Enter Contact Title" :maxlength="50" v-model="secondaryContactList.contactTitle">
                           <div v-if="errors.has('Contact Title')"> {{ errors.first('Contact Title') }} </div>
                        </td>
                        <td>
                           <input type="text"   data-vv-scope="addscontact" class="form-control input-sm"  name="Work Number" @input="formatWorkNumber" @blur="formatWorkNumber" v-model.trim="secondaryContactList.secondaryContactWorkNumber"  data-vv-as="Work Number" placeholder="Enter Work Number" maxlength="10" v-validate="'min:10|max:14'" >
                           <div v-if="errors.has('addscontact.Work Number')"> {{ errors.first('addscontact.Work Number') }} </div>
                        </td>
                        <td>
                           <input type="text"  v-model.trim="secondaryContactList.secondaryContactMobileNumber"
                              data-vv-name="Mobile Number" class="form-control input-sm"
                              data-vv-scope="addscontact"  data-vv-as="Mobile Number"
                              maxlength="10" v-validate="'min:10|max:14'"
                              @input="formatCellPhoneNumber" @blur="formatCellPhoneNumber"
                              title="Please enter 10 digits"
                              placeholder="Enter Mobile Number"
                              >
                           <div v-if="errors.has('addscontact.Mobile Number')"> {{ errors.first('addscontact.Mobile Number') }} </div>
                        </td>
                        <td>
                           <input id="fnum"
                              placeholder="Enter Fax Number" class="form-control input-sm"
                              title="Please enter 10 digits" data-vv-scope="addscontact"
                              v-model.trim="secondaryContactList.secondaryContactFaxNumber"
                              maxlength="10" v-validate="'min:10|max:14'" data-vv-name="Fax"
                              @input="formatFaxNumber"
                              @blur="formatFaxNumber"
                              />
                           <div v-if="errors.has('addscontact.Fax')"> {{ errors.first('addscontact.Fax') }} </div>
                        </td>
                        <td>
                           <input id="secondaryemail"  class="form-control input-sm"
                              placeholder="Enter email" data-vv-scope="addscontact"
                              v-model.trim="secondaryContactList.secondaryContactEmail"
                              data-vv-name="Contact Email" data-vv-as="Contact Email"  v-validate="'email'"/>
                           <div v-if="errors.has('addscontact.Contact Email')"> {{ errors.first('addscontact.Contact Email') }} </div>
                        </td>
                        <td>
                           <button type="submit" class="btn btn-secondary" @click="addSecondaryContactList">+</button>
                           <!--<button type="submit" style="width:1%" @click="addContact">-</button>-->
                        </td>
                     </tr>
                     <br>
                     <tbody>
                     <tr v-for="(entry,index) in reviewlist" :key="entry.id">
                        <td>
                           <input type="text"  :name="'reviewlist[' + index + '][secondaryContactFirstName]'"  v-validate="'required'"  data-vv-as="First Name" placeholder="Enter First Name" :maxlength="50" v-model="reviewlist[index].secondaryContactFirstName" class="form-control input-sm">
                           <div v-if="reviewlist[index].secondaryContactFirstName==''||errors.has('reviewlist[' + index + '][secondaryContactFirstName]')"> {{ errors.first('reviewlist[' + index + '][secondaryContactFirstName]') }} </div>
                        </td>
                        <td><input type="text" placeholder="Enter Middle Name" class="form-control input-sm" :maxlength="50" v-model="reviewlist[index].secondaryContactMiddleName"></td>
                        <td>
                           <input type="text" name="Last Name1" data-vv-as="Last Name1" class="form-control input-sm" placeholder="Enter Last Name" :maxlength="50" v-model="reviewlist[index].secondaryContactLastName">
                           <div v-if="reviewlist[index].secondaryContactLastName==''||errors.has('Last Name1')"> {{ errors.first('Last Name') }} </div>
                        </td>
                        <td>
                           <input type="text" name='Contact Title1' class="form-control input-sm" data-vv-as="Contact Title1" placeholder="Enter Contact Title" :maxlength="50"  v-model="reviewlist[index].contactTitle">
                           <div v-if="reviewlist[index].contactTitle==''||errors.has('Contact Title1')"> {{ errors.first('Contact Title') }} </div>
                        </td>
                        <td>
                           <input type="text"  @input="formatWorkNumber" @blur="formatWorkNumber"
                              v-model.trim="reviewlist[index].secondaryContactWorkNumber"
                              :name="'reviewlist[' + index + '][secondaryContactWorkNumber]'" class="form-control input-sm"
                              data-vv-as="Work Number" placeholder="Enter Work Number" maxlength="10" v-validate="'min:10|max:14'" >
                           <div v-if="errors.has('reviewlist[' + index + '][secondaryContactWorkNumber]')">
                              {{ errors.first(('reviewlist[' + index + '][secondaryContactWorkNumber]')) }}
                           </div>
                        </td>
                        <td>
                           <input type="text"  v-model.trim="reviewlist[index].secondaryContactMobileNumber"
                              :name="'reviewlist[' + index + '][secondaryContactMobileNumber]'"
                              data-vv-as="Mobile Number"
                              class="form-control input-sm"
                              maxlength="10" v-validate="'min:10|max:14'"
                              @input="formatCellPhoneNumber" @blur="formatCellPhoneNumber"
                              title="Please enter 10 digits"
                              placeholder="Enter Mobile Number"
                              >
                           <div v-if="errors.has('reviewlist[' + index + '][secondaryContactMobileNumber]')"> {{ errors.first(('reviewlist[' + index + '][secondaryContactMobileNumber]')) }} </div>
                        </td>
                        <td>
                           <input id="fnum"
                              placeholder="Enter Fax Number"
                              title="Please enter 10 digits"
                              class="form-control input-sm"
                              v-model.trim="reviewlist[index].secondaryContactFaxNumber"
                              :name="'reviewlist[' + index + '][secondaryContactFaxNumber]'"
                              maxlength="10" v-validate="'min:10|max:14'" data-vv-as="Fax Number"
                              @input="formatFaxNumber"
                              @blur="formatFaxNumber"
                              />
                           <div v-if="errors.has('reviewlist[' + index + '][secondaryContactFaxNumber]')"> {{ errors.first('reviewlist[' + index + '][secondaryContactFaxNumber]') }} </div>
                        </td>
                        <td>
                           <input id="secondaryemail" type="email"
                              placeholder="Enter email"
                              class="form-control input-sm"
                              v-model.trim="reviewlist[index].secondaryContactEmail"
                              :name="'reviewlist['+index+'][secondaryContactEmail1]'" data-vv-as="Email1"  v-validate="'email'"/>
                           <div v-if="errors.has('reviewlist['+index+'][secondaryContactEmail1]')" class="alert-danger" > {{ errors.first('reviewlist['+index+'][secondaryContactEmail1]') }} </div>
                        <td>
                           <button type="submit"  class="btn btn-secondary"  v-if="entry.secondaryContactId != null "    @click="deleteSecondaryContact(entry.secondaryContactFirstName ,entry.secondaryContactLastName,entry.secondaryContactEmail,entry.secondaryContactId,index)">-</button>
                           <button type="submit" v-if="entry.secondaryContactId == null "  class="btn btn-secondary"  @click="deleteContact(index)">-</button>
                        </td>
                     </tr>
                     </tbody>
                  </table>
               </div>
            </div>

            <center class="mb-5">
               <button type="submit" @click="updateDealer" class="btn btn-secondary mb-3"> Update </button>&nbsp;&nbsp;&nbsp;
               <button :hidden="hiddeninactivestatus" class="btn btn-secondary mb-3" name="add"   @click="addContact">Show/Hide Secondary Contact</button>&nbsp;&nbsp;&nbsp;

            <button type="Reset" @click="resetData" class="btn btn-secondary mb-3"> Reset </button>&nbsp;&nbsp;&nbsp;
                       <button type="Submit" @click="close" class="btn btn-secondary mb-3"> Back </button>
           </center>

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center">
                  <div class="col  justify-content-end align-items-center ">
                  </div>
            </div>
         </div>
         </div>

         <!-- End of the code for this screen here -->

        </div>
      </div>
        </div>
      </div>

</div>

  <div v-if="popUpType=='viewDeals'">

          <div class="modal-backdrop">
        <div class="card col-lg-10 col-md-8 mt-md-4 col-11 p-0">

            <div class="postmodalcontent" >

           <div class="modal-header borderbottom p-4">

                    <button type="button" class="close" @click="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                 <div class="modal-body bodymodal11">

<b>Summary Of {{selectedDealerName}}</b>

  <div class="row p-2 justify-content-center">
                <div class="col">
                  <div class="table-responsive table-responsive-sm">
                          <table  class="table table-sm table-bordered table-striped ">
                            <thead class="table-month-header-red">
                              <tr >
       <th class="table-amort-header" >Quote Count</th>
      <th class="table-amort-header" >Apps Count</th>
      <th class="table-amort-header" >Deals Count</th>

   </tr>
                            </thead>
                            <tbody  >
                    <tr class="table-month-row" v-for="(dealer,index) in dealerListForDisplayIndex" :key="index" >
       <td v-if="index =='0'"  class="table-month-td" > {{dealer.quotesCount}}</td>
       <td  v-if="index =='0'" class="table-month-td" > {{dealer.appsCount}} </td>
       <td  v-if="index =='0'" class="table-month-td" > {{dealer.dealsCount}} </td>

       </tr>
                            </tbody>
                   </table>
             </div>
           </div><!--col end-->

     </div>

 <center>
 <span :style="msgcolor">
                    <b>{{ responseMessage }}</b>
                  </span>   </center>
                  <br><br>
<div class="row">
          <div class="col-lg-3">
            <ul
              class="nav nav-tabs" role="tablist"
            >
              <li class="nav-item">
                <a
                  class="nav-link active"
                  data-toggle="tab"
                  href="#quotes"
                  role="tab"
                  @click="getAppsAndDeals('quote')"
                  >Quotes</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  data-toggle="tab"
                href="#apps"
                  role="tab"
                    @click="getAppsAndDeals('application')"
                  >Apps</a
                >
              </li>
             <li >
                <a
                  class="nav-link"
                  data-toggle="tab"
                  href="#deals"
                  role="tab"
                    @click="getAppsAndDeals('deals')"
                  >Deals</a
                >
              </li>

            </ul>
          </div>
</div>

<div class="tab-content" id="myTabContent">

<div role="tabpanel" class="tab-pane fade show active"  id="quotes">
                 <div >
                  <nav>

<div class="row mt-2 justify-content-center">
              <div class="col">
                <div class="table-responsive table-responsive-sm tbl-update-dealer">
                  <v-table
                    id="dealerListTable"
                    :data="dealerListForDisplay"
                    class="table table-sm table-bordered table-striped"
                  >
                    <thead class="table-month-header-blue wrap-text" slot="head">
                         <v-th sortKey="dateOfQuote">Date Of Quote</v-th>
                        <v-th sortKey="dealerName">Dealer Name</v-th>
                      <v-th sortKey="customerFirstName">Customer First Name</v-th>
                      <v-th sortKey="customerMiddleName">Customer Middle Name</v-th>
                      <v-th sortKey="customerLastName">Customer Last Name</v-th>
                      <v-th sortKey="customerBusinessName">Customer Business Name</v-th>
                      <v-th sortKey="customerType">Customer Type</v-th>
                      <v-th sortKey="capCost">Cap Cost</v-th>
                       <v-th sortKey="dealerState">Dealer State</v-th>

                    </thead>
                    <tbody slot="body" slot-scope="{ displayData }">
                      <tr v-for="(quote,dindex) in displayData" :key="dindex">

                        <td class="table-month-td">{{quote.dateOfQuote}}</td>
                        <td class="table-month-td">{{quote.dealerName}}</td>
                        <td class="table-month-td">{{quote.customerFirstName}}</td>
                        <td class="table-month-td">{{quote.customerMiddleName}}</td>
                        <td class="table-month-td">{{ quote.customerLastName }}</td>

                        <td class="table-month-td">{{quote.customerBusinessName}}</td>
                         <td class="table-month-td">{{quote.customerType}}</td>
                         <td class="table-month-td">{{quote.capCost}}</td>
                          <td class="table-month-td">{{quote.dealerState}}</td>

                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>

                  </nav>
                </div>
                <div
                  class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
                >
                 </div></div>

<div role="tabpanel" class="tab-pane" id="apps">
                <div>
                  <nav>

<div class="row mt-2 justify-content-center">
              <div class="col">
                <div class="table-responsive table-responsive-sm tbl-update-dealer">
                  <v-table
                    id="dealerListTable"
                    :data="dealerListForDisplay"
                    class="table table-sm table-bordered table-striped"
                  >
                    <thead class="table-month-header-blue wrap-text" slot="head">
                         <v-th sortKey="dateOfApplication">Date Of Application</v-th>
                        <v-th sortKey="dealerName">Dealer Name</v-th>
                      <v-th sortKey="customerFirstName">Customer First Name</v-th>
                      <v-th sortKey="customerMiddleName">Customer Middle Name</v-th>
                      <v-th sortKey="customerLastName">Customer Last Name</v-th>
                      <v-th sortKey="customerBusinessName">Customer Business Name</v-th>
                      <v-th sortKey="customerType">Customer Type</v-th>
                      <v-th sortKey="year">Year</v-th>
                       <v-th sortKey="make">Make</v-th>
                        <v-th sortKey="model">Model</v-th>
                       <v-th sortKey="dealSource">Deal Source</v-th>
                      <v-th sortKey="applicationStatus">Application Status</v-th>
                       <v-th sortKey="appDeclineCategory">App Decline Category</v-th>

                        <v-th sortKey="appDeclineReason">App Decline Reason</v-th>
                       <v-th sortKey="expectedAdvance">Expected Advance</v-th>
                        <v-th sortKey="probToClose">Prob to Close</v-th>
                       <v-th sortKey="dealStatus">Deal Status</v-th>
                        <v-th sortKey="dealDeclineReason">Deal Decline Reason</v-th>

                       <v-th sortKey="appState">App State</v-th>
                      <v-th sortKey="fundedDate">Funded Date</v-th>
                    </thead>
                    <tbody slot="body" slot-scope="{ displayData }">
                      <tr v-for="(quote,dindex) in displayData" :key="dindex">

                        <td class="table-month-td">{{quote.dateOfApplication}}</td>
                        <td class="table-month-td">{{quote.dealerName}}</td>
                        <td class="table-month-td">{{quote.customerFirstName}}</td>
                        <td class="table-month-td">{{quote.customerMiddleName}}</td>
                        <td class="table-month-td">{{ quote.customerLastName }}</td>
                        <td class="table-month-td">{{quote.customerBusinessName}}</td>
                         <td class="table-month-td">{{quote.customerType}}</td>
                         <td class="table-month-td">{{quote.year}}</td>
                          <td class="table-month-td">{{quote.make}}</td>
                         <td class="table-month-td">{{quote.model}}</td>
                         <td class="table-month-td">{{quote.dealSource}}</td>
                         <td class="table-month-td">{{quote.applicationStatus}}</td>
                          <td class="table-month-td">{{quote.appDeclineCategory}}</td>
                            <td class="table-month-td">{{quote.appDeclineReason}}</td>
                         <td class="table-month-td">{{quote.expectedAdvance}}</td>
                         <td class="table-month-td">{{quote.probToClose}}</td>
                         <td class="table-month-td">{{quote.dealStatus}}</td>
                            <td class="table-month-td">{{quote.dealDeclineReason}}</td>
                         <td class="table-month-td">{{quote.appState}}</td>
                         <td class="table-month-td">{{quote.fundedDate}}</td>

                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>

                  </nav>
                </div>
                <div
                  class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
                >
                 </div></div>
 <div role="tabpanel" class="tab-pane" id="deals">
                <div>
                  <nav>

                    <div class="row mt-2 justify-content-center">
              <div class="col">
                <div class="table-responsive table-responsive-sm tbl-update-dealer">
                  <v-table
                    id="dealerListTable"
                    :data="dealerListForDisplay"
                    class="table table-sm table-bordered table-striped"
                  >
                    <thead class="table-month-header-blue wrap-text" slot="head">
                         <v-th sortKey="dateOfApplication">Date Of Application</v-th>
                        <v-th sortKey="dealerName">Dealer Name</v-th>
                      <v-th sortKey="customerFirstName">Customer First Name</v-th>
                      <v-th sortKey="customerMiddleName">Customer Middle Name</v-th>
                      <v-th sortKey="customerLastName">Customer Last Name</v-th>
                      <v-th sortKey="customerBusinessName">Customer Business Name</v-th>
                      <v-th sortKey="customerType">Customer Type</v-th>
                      <v-th sortKey="year">Year</v-th>
                       <v-th sortKey="make">Make</v-th>
                        <v-th sortKey="model">Model</v-th>
                       <v-th sortKey="dealSource">Deal Source</v-th>
                      <v-th sortKey="applicationStatus">Application Status</v-th>
                       <v-th sortKey="appDeclineCategory">App Decline Category</v-th>

                        <v-th sortKey="appDeclineReason">App Decline Reason</v-th>
                       <v-th sortKey="expectedAdvance">Expected Advance</v-th>
                        <v-th sortKey="probToClose">Prob to Close</v-th>
                       <v-th sortKey="dealStatus">Deal Status</v-th>
                        <v-th sortKey="dealDeclineReason">Deal Decline Reason</v-th>

                       <v-th sortKey="appState">App State</v-th>
                      <v-th sortKey="fundedDate">Funded Date</v-th>
                    </thead>
                    <tbody slot="body" slot-scope="{ displayData }">
                      <tr v-for="(quote,dindex) in displayData" :key="dindex">

                        <td class="table-month-td">{{quote.dateOfApplication}}</td>
                        <td class="table-month-td">{{quote.dealerName}}</td>
                        <td class="table-month-td">{{quote.customerFirstName}}</td>
                        <td class="table-month-td">{{quote.customerMiddleName}}</td>
                        <td class="table-month-td">{{ quote.customerLastName }}</td>
                        <td class="table-month-td">{{quote.customerBusinessName}}</td>
                         <td class="table-month-td">{{quote.customerType}}</td>
                         <td class="table-month-td">{{quote.year}}</td>
                          <td class="table-month-td">{{quote.make}}</td>
                         <td class="table-month-td">{{quote.model}}</td>
                         <td class="table-month-td">{{quote.dealSource}}</td>
                         <td class="table-month-td">{{quote.applicationStatus}}</td>
                          <td class="table-month-td">{{quote.appDeclineCategory}}</td>
                            <td class="table-month-td">{{quote.appDeclineReason}}</td>
                         <td class="table-month-td">{{quote.expectedAdvance}}</td>
                         <td class="table-month-td">{{quote.probToClose}}</td>
                         <td class="table-month-td">{{quote.dealStatus}}</td>
                            <td class="table-month-td">{{quote.dealDeclineReason}}</td>
                         <td class="table-month-td">{{quote.appState}}</td>
                         <td class="table-month-td">{{quote.fundedDate}}</td>

                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>
                  </nav>
                </div>
              </div>

</div>

  <center class="mb-5">
    <button type="Reset" @click="close" class="btn btn-secondary mb-3"> Back </button>
    </center>

                    </div></div>   </div></div></div>

   </div>
   </div>
   </div>

</template>

<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import { store } from '../store.js'
import manageSourceSvc from '../js/http-managesource'
import manageemployeeSvc from '../js/http-employee.js'
import commonservice from '../js/http-common'
import { bus } from '../main'
import { stringify } from 'querystring'

export default {
  components: { MainMenu,
    TopHeader,
    BottomFooter
  },
  name: 'updatedealer',
  data () {
    return {

      responseMessage: '',
      viewDealsType: 'quote',
      viewDealsCountType: 'dealer',
      dealerListForDisplay: [],
      dealerListForDisplayIndex: [],
      selectedDealerName: this.$store.state.dealerName,
      pageloader: true,
      fraudIndicatorList: [],
      redFlagReasonList: [],
      hiddeninactivestatus: false,
      disableemployeedd: false,
      id: 0,
      selectedDealerId: this.$store.state.dealerId, // this is when coming from update dealer
      popUpType: this.$store.state.popUpType,
      states: [], // gets data from service
      preferredContactOptions: [], // gets data from service

      msgcolor: {
        color: 'black'
      },
      priortyList: [
        { key: '1', value: '1' },
        { key: '2', value: '2' },
        { key: '3', value: '3' },
        { key: '4', value: '4' },
        { key: '5', value: '5' }
      ],
      appSourceList: [
        { key: '1', value: 'Dealer Track' },
        { key: '2', value: 'Route One' },
        { key: '3', value: 'Other' }
      ],
      dealerStatusOptions: [],
      dealer: this.initializedata(), // intialize dealer entry fields
      saved: false,
      message: '',
      failure: false,
      failureMessage: "We're sorry, We're unable to Update dealer information at the moment, please try later",
      agentList: [],
      empAssignment: this.initializeEmpdata(),
      assignedAgentID: '',
      reviewlist: [],
      addSecondaryContact: false,
      secondaryContactList: [{
        secondaryContactFirstName: '',
        secondaryContactMiddleName: '',
        secondaryContactLastName: '',
        contactTitle: '',
        secondaryContactWorkNumber: '',
        secondaryContactMobileNumber: '',
        secondaryContactFaxNumber: '',
        secondaryContactEmail: ''
      }],
      secondarycontactscolnames: [
        { header: 'First Name *' },
        { header: 'Middle Name' },
        { header: 'Last Name' },
        { header: 'Contact Title' },
        { header: 'Work Number' },
        { header: 'Mobile Number' },
        { header: 'Fax Number' },
        { header: 'Email' },
        { header: 'Action' }
      ]
    }
  },
  props: [
    'UpdateDealerObject'
  ],
  methods: {
    zipDecoder () {
      if (this.dealer.zipcode.length == 5) {
        commonservice.get('/statefip/zipCode/' + this.dealer.zipcode)
          .then(response => {
            if (response.data.city != null) {
              this.dealer.city = response.data.city
            } else {
              this.dealer.city = ''
            }
            if (response.data.city != null) {
              this.getDealerStateDetails(response.data.state)
            } else {
              this.dealer.stateCode = ''
            }
          })

          .catch(e => { this.errorslist.push(e) })
      }
    },
    getDealerStateDetails (stateFipsC) {
      for (let i = 0; i < this.states.length; i++) {
        if (this.states[i].stateAlphaC == stateFipsC) {
          // this.customer.selectedStateCode = this.states[i];
          this.dealer.stateCode = this.states[i].stateFipsC
          console.log('Customer Object : ' + JSON.stringify(this.states[i]))
        }
      }
    },
    close () {
      this.$emit('closeUpdateDealerModal', 'cancel')
    },

    /* eslint-disable no-console */
    formatPhoneNumber: function (event) {
      var phone = this.dealer.officeNum
      phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.dealer.officeNum = phone
    },
    formatCellPhoneNumber: function (event) {
      var phone = this.secondaryContactList.secondaryContactMobileNumber
      if (this.secondaryContactList.secondaryContactMobileNumber != null) {
        phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
        this.secondaryContactList.secondaryContactMobileNumber = phone
      }
    },
    formatWorkNumber: function (event) {
      var phone = this.secondaryContactList.secondaryContactWorkNumber
      phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.secondaryContactList.secondaryContactWorkNumber = phone
    },
    formatFaxNumber: function (event) {
      var phone = this.secondaryContactList.secondaryContactFaxNumber
      if (this.secondaryContactList.secondaryContactFaxNumber != null) {
        phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
        this.secondaryContactList.secondaryContactFaxNumber = phone
      }
    },
    fetchData () {
      this.getAppsAndDeals(this.viewDealsType)
      commonservice.get('/statefip/').then(response => {
        this.states = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
      commonservice.get('/staticdata/preferredcontact/').then(response => {
        this.preferredContactOptions = response.data
      })
        .catch(e => { this.errors.push(e) })

      commonservice.get('/staticdata/status/').then(response => {
        this.dealerStatusOptions = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    resetData () {
      this.reviewlist = []
      this.retrieveDealerData()
    },
    addSecondaryContactList () {
      var rownum = 0
      // for (var i = 0; i < this.reviewlist.length; i++) {
      //     rownum = i+1;
      //     this.secondaryContactList[i].rownumber = rownum;
      //   }

      this.$validator.validateAll('addscontact').then((isValid) => {
        if (isValid) {
          this.reviewlist.push({

            'rownumber': rownum + 1,
            'SecondaryContactDealerId': this.dealer.dealerId,
            'secondaryContactFirstName': this.secondaryContactList.secondaryContactFirstName,
            'secondaryContactMiddleName': this.secondaryContactList.secondaryContactMiddleName,
            'secondaryContactLastName': this.secondaryContactList.secondaryContactLastName,
            'contactTitle': this.secondaryContactList.contactTitle,
            'secondaryContactWorkNumber': this.secondaryContactList.secondaryContactWorkNumber,
            'secondaryContactMobileNumber': this.secondaryContactList.secondaryContactMobileNumber,
            'secondaryContactFaxNumber': this.secondaryContactList.secondaryContactFaxNumber,
            'secondaryContactEmail': this.secondaryContactList.secondaryContactEmail
          })
          // console.log(this.reviewlist)
          this.secondaryContactList.secondaryContactFirstName = ''
          this.secondaryContactList.secondaryContactMiddleName = ''
          this.secondaryContactList.secondaryContactLastName = '',
          this.secondaryContactList.secondaryContactFaxNumber = '',
          this.secondaryContactList.secondaryContactEmail = '',
          this.secondaryContactList.contactTitle = '',
          this.secondaryContactList.secondaryContactMobileNumber = '',
          this.secondaryContactList.secondaryContactWorkNumber = '',
          this.addSecondaryContact = true
        }
      })
    },
    updateDealer () {
      // Reset any data
      this.failure = false
      this.message = ''
      this.addSecondaryContact = false
      var currentDate = new Date()
      //  if(this.addSecondaryContact==true)
      //  {
      //    this.errorslist=[];
      //    this.errors.clear();
      //    this.$validator.reset();
      //  }
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          let updateDealerPayload = {
            'dealerId': this.selectedDealerId, // can also be this.dealer.dealerId
            'dealerName': this.dealer.dealerName,
            'firstName': this.dealer.firstName,
            'middleName': this.dealer.middleName,
            'lastName': this.dealer.lastName,
            'contactTitle': this.dealer.contactTitle,
            'address': {
              'addressId': this.dealer.addressId,
              'street1': this.dealer.addressLine1,
              'street2': this.dealer.addressLine2,
              'city': this.dealer.city,
              'zipCode': this.dealer.zipcode,
              'stateFipsC': this.dealer.stateCode == null ? null : this.dealer.stateCode,
              'country': this.dealer.country,
              'addressType': null, // TODO- Set as Mailing
              // "inactiveD": null,
              'creationD': this.dealer.createdDate,
              'creationUserI': this.dealer.createdUserId,
              // "lastUpdatedD": currentDate,
              'lastUpdatedUserI': this.$session.get('user_id')
            },
            'digitalContactInfo': {
              'digitalContactId': this.dealer.digitalContactId,
              'preferredContact': this.dealer.preferredContact,
              // "workNumber": this.dealer.officeNum.replace(/[^0-9]/g,''),
              'email': this.dealer.email
            },
            'priority': this.dealer.priority,
            'dealerStatue': this.dealer.status,
            'appSource': this.dealer.appSource,
            'fraudInd': this.dealer.fraudInd,
            'redFlagReason': this.dealer.redFlagReason,
            'inactiveD': (this.dealer.status == 'A' ? null : currentDate),
            'creationD': this.dealer.createdDate,
            'creationUserI': this.dealer.createdUserId,
            // "lastUpdatedD": currentDate,
            'lastUpdatedUserI': this.$session.get('user_id'),
            'dealerSecondaryContacts': this.constructSecondayContacts(currentDate)
          }
          // console.log("Payload for update dealer:"+updateDealerPayload);
          // Call REST API
          manageSourceSvc
            .put('/dealer/' + this.selectedDealerId, updateDealerPayload)
            .then(response => {
              var status = response.data
              if (status == 'ACCEPTED') {
                // console.log("Dealer Updated successfully!!");
                this.saved = true
                this.message = 'Dealer has been updated successfully!!!'
                this.reviewlist = []
                this.secondaryContactList = []
                // Update Dealer Assignment to Employee
                if (this.empAssignment.employeeId != null) {
                  this.updateAgentAssignment()
                }
                this.dealer = this.initializedata()
                this.assignedAgentID = ''
                this.errors.clear()
                this.$validator.reset()
                // Got to View Dealers?
                // this.$router.push('/viupdateDealer');
                if (this.message == 'Dealer has been updated successfully!!!');
                this.close()
              } else if (status == 'BAD_REQUEST') {
                // console.log("Failed to update Dealer!!");
                // this.saved= false;
                this.failure = true
                this.message = "We're sorry there is system Error, please try again or contact us"
              } else {
                // console.log("Failed to update Dealer!!");
                this.failure = true
                this.message = "We're sorry there is system Error, please try again or contact us"
              }
              // TODO= Handle following scenarios - Dealer Already exists, 500 or any other Status Codes
            })
            .catch(e => {
              console.log('Failed: ' + e)
              this.failure = true
              this.message = "We're sorry there is system Error, please try again or contact us"
            })
        }
      })
    },
    constructSecondayContacts: function (currentDate) {
      var ebcrlist = []
      var currentDate = new Date()
      // console.log("hello"+JSON.stringify(this.reviewlist))
      if (this.reviewlist.length > 0) {
        for (var i = 0; i < this.reviewlist.length; i++) {
          var reviewobject = this.reviewlist[i]
          ebcrlist.push({
            'inactiveD': null,
            'creationD': currentDate,
            'creationUserI': this.$session.get('user_id'),
            'lastUpdatedD': null,
            'lastUpdatedUserI': null,
            'dealerId': reviewobject.SecondaryContactDealerId,
            'dealerContactId': reviewobject.secondaryContactId,
            'firstName': reviewobject.secondaryContactFirstName,
            'middleName': reviewobject.secondaryContactMiddleName,
            'lastName': reviewobject.secondaryContactLastName,
            'contactTitle': reviewobject.contactTitle,
            'workNumber': reviewobject.secondaryContactWorkNumber == null ? null : reviewobject.secondaryContactWorkNumber.replace(/[^0-9]/g, ''),
            'mobileNumber': (reviewobject.secondaryContactMobileNumber == null ? null : reviewobject.secondaryContactMobileNumber.replace(/[^0-9]/g, '')),
            'faxNumber': (reviewobject.secondaryContactFaxNumber == null ? null : reviewobject.secondaryContactFaxNumber.replace(/[^0-9]/g, '')),
            'email': reviewobject.secondaryContactEmail

          })
        }
      }
      // console.log("js"+JSON.stringify(ebcrlist))
      return ebcrlist
    },
    deleteContact: function (index) {
      this.reviewlist.splice(index, 1)
    },
    deleteSecondaryContact: function (firstName, lastName, email, secondaryContactId, index) {
      manageSourceSvc.delete('/dealerSecondaryContactsByContactId/' + secondaryContactId).then(response => {
        var status = response.data
        if (status === 'OK') {
          this.reviewlist.splice(index, 1)
          // this.getdealerdata()
        } // this.retrieveDealerData()
      })
    },
    getAppsAndDeals (value) {
      this.dealerListForDisplay = [],
      this.responseMessage = ''
      this.viewDealsType = value
      manageSourceSvc.get('/getAppsAndDealsData', {
        params: {

          viewDealsType: this.viewDealsType,
          dealerName: this.selectedDealerName }
      })
        .then(Response => {
          this.dealerListForDisplay = Response.data

          if (this.dealerListForDisplay == '') {
            this.responseMessage = 'No Records Found'
          }
          console.log(JSON.stringify(this.dealerListForDisplay))
        })
        .catch(error => {
          console.log('Failed to load dealer on page load:' + error)
          this.error = true
        })
        .finally(() => (this.loading = false))
    },

    getAppsAndDealsIndex (value) {
      this.viewDealsCountType = value
      manageSourceSvc.get('/getAppsAndDealsDataCount', {
        params: {

          viewDealsType: this.viewDealsCountType,
          dealerName: this.selectedDealerName,
          customerId: 0 }
      })
        .then(Response => {
          this.dealerListForDisplayIndex = Response.data
          console.log(JSON.stringify(this.dealerListForDisplayIndex))
        })
        .catch(error => {
          console.log('Failed to load dealer on page load:' + error)
          this.error = true
        })
        .finally(() => (this.loading = false))
    },

    getdealerdata () {
      manageSourceSvc.get('/dealerbyid/' + this.selectedDealerId).then(response => {
        // this.reviewlist=[]

        // console.log(JSON.stringify("FROM DELETE : " + response.data.dealerSecondaryContacts.length))
        for (var i = 0; i < response.data.dealerSecondaryContacts.length; i++) {
          var secondarycontacts = response.data.dealerSecondaryContacts[i]

          // console.log(JSON.stringify(secondarycontacts))
          // numberofrows= numberofrows+1;
          // this.reviewlist = []
          this.reviewlist.push({
            id: id,
            'SecondaryContactDealerId': secondarycontacts.dealerId,
            'secondaryContactId': secondarycontacts.dealerContactId,
            'secondaryContactFirstName': secondarycontacts.firstName,
            'secondaryContactMiddleName': secondarycontacts.middleName,
            'secondaryContactLastName': secondarycontacts.lastName,
            'secondaryContactContactTitle': secondarycontacts.contactTitle,
            'secondaryContactWorkNumber': secondarycontacts.workNumber == null ? null : secondarycontacts.workNumber.replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3'),
            'secondaryContactMobileNumber': secondarycontacts.mobileNumber == null ? null : secondarycontacts.mobileNumber.replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3'),
            'secondaryContactFaxNumber': secondarycontacts.faxNumber == null ? null : secondarycontacts.faxNumber.replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3'),
            'secondaryContactEmail': secondarycontacts.email
          })

          id++
        }
      })
    },

    deleteAssignment () {
      var ebcrlist1 = []
      var currentDate = new Date()
      ebcrlist1.push({
        'inactiveD': null,
        'creationD': currentDate,
        'creationUserI': this.empAssignment.creationUser,
        'lastUpdatedUserI': this.$session.get('user_id'),
        'id': {
          'employeeId': this.empAssignment.employeeId,
          'dealerId': this.empAssignment.dealerId,
          'regionC': this.empAssignment.regionC,
          'stateFipsC': this.empAssignment.stateFipsC
        }
      })
      manageemployeeSvc.delete('/empbusinesscoveragearea', { data: ebcrlist1 }).then(response => {
        // console.log("Update status: " + response.status)
      })
        .catch(e => {
          console.log('Failed: ' + e)
          // this.failure = true;
        })
    },
    addContact () {
      if (this.addSecondaryContact == true) { this.addSecondaryContact = false } else { this.addSecondaryContact = true }
    },
    dealerFraud () {
      if (this.dealer.fraudInd == 'N') { this.dealer.redFlagReason = '' }
    },
    updateAgentAssignment () {
      var state = this.dealer.stateCode
      var empid = this.assignedAgentID
      var dealerId = this.selectedDealerId
      // Check if Delete?
      if (this.assignedAgentID == 'RA') {
        // Delete here
        // console.log(this.assignedAgentID)
        this.deleteAssignment()
      } else {
      // insert or Update
        if (empid == this.empAssignment.employeeId) {
          // nothing changed
        } else {
        // Determine if Update, Then Delete first
          if (this.empAssignment.employeeId !== null) {
            this.deleteAssignment()
          }
          // Insert or update
          commonservice.get('regionstates/state/' + state)
            .then(response => response.data)
            .then(data => {
              var region = data.id.regionC
              var ebcrlist = []
              var currentDate = new Date()
              ebcrlist.push({
                'inactiveD': null,
                'creationD': currentDate,
                'creationUserI': (this.empAssignment.creationUser == null ? this.$session.get('user_id') : this.empAssignment.creationUser),
                'lastUpdatedUserI': this.$session.get('user_id'),
                'id': {
                  'employeeId': empid,
                  'dealerId': dealerId,
                  'regionC': region,
                  'stateFipsC': state
                }
              })
              manageemployeeSvc.put('/empbusinesscoveragearea', ebcrlist).then(response => {
                // console.log("Update status: " + response.status)
              })
                .catch(e => {
                  console.log('Failed: ' + e)
                  // this.failure = true;
                })
            })
            .catch(e => {
              console.log('ERROR in getting saved Region')
              // this.errors.push(e);
            })
        } // END ELSE
      } // END OUTER ELSE
    },
    initializeEmpdata () {
      return {
        regionC: '',
        stateFipsC: '',
        employeeId: '',
        dealerId: '',
        creationUser: ''
      }
    },

    initializedata () {
      return {
        dealerId: '',
        dealerName: '',
        firstName: '',
        middleName: '',
        lastName: '',
        contactTitle: '',
        addressId: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        stateCode: '',
        country: 'USA',
        zipcode: '',
        digitalContactId: '',
        officeNum: '',
        email: '',
        preferredContact: 'A',
        priority: '',
        status: '',
        createdDate: '',
        createdUserId: '',
        // salesAgentId:'',
        appSource: '',
        redFlagReason: '',
        fraudInd: 'N'
      }
    },
    retrieveAssignedEmpData () {
      manageemployeeSvc.get('/empbusinesscoveragearea/dealer/' + this.selectedDealerId).then(response => {
        this.empAssignment = {
          creationUser: response.data.creationUserI,
          regionC: response.data.id.regionC,
          stateFipsC: response.data.id.stateFipsC,
          employeeId: response.data.id.employeeId,
          dealerId: response.data.id.dealerId
        }

        var employeeExist = false
        for (let i = 0; i < this.agentList.length; i++) {
          if (this.agentList[i].employeeId == this.empAssignment.employeeId) {
            employeeExist = true
            break
          }
        }

        if (employeeExist) {
          this.assignedAgentID = this.empAssignment.employeeId
        } else {
          this.assignedAgentID = ''
        }
      }).catch(e => {
        console.log(e)
      })
    },
    // Get the Dealer Data when coming from view/update screen
    retrieveDealerData () {
      manageSourceSvc.get('/dealerbyid/' + this.selectedDealerId).then(response => {
        // console.log(JSON.stringify(response.data))

        this.dealer = {
          dealerId: response.data.dealerId,
          dealerName: response.data.dealerName,
          firstName: response.data.firstName,
          middleName: response.data.middleName,
          fraudInd: response.data.fraudInd == null ? '' : response.data.fraudInd,
          lastName: response.data.lastName,
          contactTitle: response.data.contactTitle,
          addressId: response.data.addressId,
          addressLine1: response.data.address.street1,
          addressLine2: response.data.address.street2,
          city: response.data.address.city,
          stateCode: response.data.address.stateFipsC,
          country: response.data.address.country == null || response.data.address.country == '' ? 'USA' : response.data.address.country,
          zipcode: response.data.address.zipCode,
          digitalContactId: response.data.digitalContactInfo.digitalContactId,
          officeNum: response.data.digitalContactInfo.workNumber, // .replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3'),
          fax: response.data.digitalContactInfo.faxNumber,
          email: response.data.digitalContactInfo.email,
          preferredContact: response.data.digitalContactInfo.preferredContact == null || response.data.digitalContactInfo.preferredContact == '' || response.data.digitalContactInfo.preferredContact == 'All'  ? 'A' : response.data.digitalContactInfo.preferredContact,
          priority: response.data.priority == null ? '1' : response.data.priority,
          appSource: response.data.appSource == null ? '' : response.data.appSource,
          status: (response.data.inactiveD == null ? 'A' : 'IA'),
          createdDate: response.data.creationD,
          createdUserId: response.data.creationUserI,
          redFlagReason: response.data.redFlagReason == null ? '' : response.data.redFlagReason

        }
        if (this.dealer.status == 'IA') {
          this.hiddeninactivestatus = true
        }
        var numberofrows = 0

        // console.log(JSON.stringify(response.data.dealerSecondaryContacts))
        for (var i = 0; i < response.data.dealerSecondaryContacts.length; i++) {
          var secondarycontacts = response.data.dealerSecondaryContacts[i]
          numberofrows = numberofrows + 1
          this.reviewlist.push({
            'SecondaryContactDealerId': secondarycontacts.dealerId,
            'secondaryContactId': secondarycontacts.dealerContactId,
            'secondaryContactFirstName': secondarycontacts.firstName,
            'secondaryContactMiddleName': secondarycontacts.middleName,
            'secondaryContactLastName': secondarycontacts.lastName,
            'contactTitle': secondarycontacts.contactTitle,
            'secondaryContactWorkNumber': secondarycontacts.workNumber == null ? null : secondarycontacts.workNumber.replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3'),
            'secondaryContactMobileNumber': secondarycontacts.mobileNumber == null ? null : secondarycontacts.mobileNumber.replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3'),
            'secondaryContactFaxNumber': secondarycontacts.faxNumber == null ? null : secondarycontacts.faxNumber.replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3'),
            'secondaryContactEmail': secondarycontacts.email
          })
        }

        this.addSecondaryContact = true

        // console.log(JSON.stringify(this.reviewlist))
      })
        .catch(e => {
          console.log(e)
        })
    },
    retrieveAgentList () {
      if (this.$session.get('user_role') == 'SR') {
        this.disableemployeedd = true
        this.agentList = [
          { 'employeeId': this.$session.get('employee_id'),
            'firstName': this.$session.get('first_name'),
            'lastName': this.$session.get('last_name'),
            'middleName': this.$session.get('middle_name')
          }
        ]
        this.assignedAgentID = this.$session.get('employee_id')
      } else {
        let searchEmployee = {
          'firstName': '',
          'lastName': '',
          'roleType': 'SR',
          'statusCode': 'A'
        }
        manageemployeeSvc.post('/employee/search/', searchEmployee).then(response => {
          this.agentList = response.data
        })
          .catch(e => {
            // console.log("Failed to load salesperson:" +e)
          })
      }
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#employee').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },

  mounted () {
    this.getAppsAndDeals(this.viewDealsType)
    this.getAppsAndDealsIndex(this.viewDealsCountType)
    this.myFunction()
    this.menuheight()
    commonservice.get('/keyvalues/getkeyvalues/' + 1).then(response => { this.fraudIndicatorList = response.data }).catch(e => { this.errorslist.push(e) })
    commonservice
      .get('/keyvalues/getkeyvalues/' + 23)
      .then(response => {
        this.redFlagReasonList = response.data
        console.log(response.data)
      })
      .catch(e => {
        this.errorslist.push(e)
      })
    this.fetchData()
    //  request came from view/update  Dealer
    this.selectedDealerId = this.$store.state.dealerId
    this.selectedDealerName = this.$store.state.dealerName
    // console.log("Dealer Id for update: "+this.selectedDealerId);
    if (this.selectedDealerId != '') {
      this.retrieveDealerData()
      this.retrieveAgentList()
      this.retrieveAssignedEmpData()
    }
  }
  /* eslint-disable no-console */
}
</script>

<style scoped>

.bottom{
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}

.modal-backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000 !important;
}
.pageloader {
  width: 7%;
  margin-top: 5%;
  margin-bottom: 5%;
  margin-left: 46%;
}
#introVideo{
  width: 100%;
  background: black;
}
.card {
    padding: -5px !important;
    margin: 0 auto;
}
label input[type="radio"]:checked ~ span {
    color: #007AFF;
}
.postmodalcontent{
  border: none !important;
}
.btn:focus{
  box-shadow: none;
}
.tagLineReport{
	height: 10px;
	color: #1F1F1F;
	font-size: 10px;
	font-weight: bold;
	letter-spacing: 0;
	font-style: italic;
  opacity: 60%
}
.button-cancel11 {
  border: 1px solid #1f1f1f;
  border-radius: 4px;
  transition : ease-out 0.3s;
  font-size: 14px !important;
	position: relative;
	z-index : 1;
}
.modal-header{
  border: none;
}
.bodymodal11{
  padding: 0 !important;
  height: 80vh;
  overflow-y: auto;

}
.bodymodal11{
  background-color: white;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
/*hide scroll bar */
/*.bodymodal11::-webkit-scrollbar {
  display: none;
}*/
/* Hide scrollbar for IE, Edge and Firefox */

/*.bodymodal11 {
  -ms-overflow-style: none;
  scrollbar-width: none;
}*/
.close{
  padding: 1px 7px 5px 7px !important;
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.close:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.loadingBgImg{
  background: transparent url('../assets/logout.png') center no-repeat;
  background-size: 30px 30px;
}
@media screen and  (max-width : 600px){
  .card{
    margin-top: 4%;
  }
}
.nav-link {
    display: block;
    padding: 0.5rem 1rem;
    background-color: #17a2b8;
    color: black;
    margin-left: 5px;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: black;
    background-color: white;
    border-color: #A9A9A9;
    border-bottom: none;
}

.sidebyside {
  float: right;
}
</style>
